export const KB_PAGE = 'reports/kb/KB_PAGE'
